import { render, staticRenderFns } from "./BacthUsers.vue?vue&type=template&id=59083772&scoped=true";
import script from "./BacthUsers.vue?vue&type=script&lang=js";
export * from "./BacthUsers.vue?vue&type=script&lang=js";
import style0 from "./BacthUsers.vue?vue&type=style&index=0&id=59083772&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "59083772", null);
export default component.exports;